const _excluded = ["testid", "capitalize"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { TextButton } from 'seagull';
import { useIoContext } from "../contexts";
export default function ContactSupportButton(props) {
  const {
      testid,
      capitalize
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    getIntercom
  } = useIoContext();
  const contactText = capitalize ? 'Contact' : 'contact';
  return /*#__PURE__*/React.createElement(TextButton, _extends({}, rest, {
    type: "button",
    "data-testid": testid,
    onClick: () => getIntercom()('showNewMessage')
  }), contactText, " Support");
}